import React from 'react';
import { ErrorBoundary } from '../../services/errorHandlingService';

const GlobalErrorFallback = ({ error, resetErrorBoundary }) => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center items-center p-4">
      <div className="max-w-md w-full bg-white shadow-lg rounded-lg p-6 border-t-4 border-red-500">
        <div className="flex items-center mb-4">
          <svg className="h-8 w-8 text-red-500 mr-3" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
          </svg>
          <h2 className="text-xl font-bold text-gray-800">Something went wrong</h2>
        </div>
        
        <p className="text-gray-600 mb-4">
          We encountered an error while rendering this page. Please try refreshing or contact support if the problem persists.
        </p>
        
        {process.env.NODE_ENV === 'development' && (
          <div className="mt-4 p-3 bg-gray-100 rounded-md">
            <h3 className="text-sm font-semibold text-gray-700 mb-2">Error details:</h3>
            <p className="text-sm font-mono text-red-600 break-words">{error.message}</p>
            {error.stack && (
              <details className="mt-2">
                <summary className="text-sm text-gray-700 cursor-pointer">Stack trace</summary>
                <pre className="mt-2 p-2 bg-gray-800 text-gray-200 rounded text-xs overflow-auto max-h-64">
                  {error.stack}
                </pre>
              </details>
            )}
          </div>
        )}
        
        <div className="mt-6 flex justify-end">
          <button
            onClick={resetErrorBoundary}
            className="bg-indigo-600 hover:bg-indigo-700 text-white font-medium py-2 px-4 rounded transition duration-150 ease-in-out"
          >
            Try again
          </button>
        </div>
      </div>
    </div>
  );
};

const GlobalErrorBoundary = ({ children }) => {
  const handleReset = () => {
    // Optionally perform some cleanup or reset app state here
    window.location.href = '/'; // Redirect to home page on reset
  };

  return (
    <ErrorBoundary
      FallbackComponent={GlobalErrorFallback}
      onReset={handleReset}
      onError={(error, info) => {
        // Log error to monitoring service like Sentry
        console.error('Caught by error boundary:', error, info);
      }}
    >
      {children}
    </ErrorBoundary>
  );
};

export default GlobalErrorBoundary; 